import ErrorBoundary from '@/core/components/errors/ErrorBoundary';
import ErrorBoundaryFallback from '@/core/components/errors/ErrorBoundaryFallback';

export { ErrorBoundary, ErrorBoundaryFallback };
